import wixWindow from 'wix-window';
import wixData from 'wix-data';
let items;
$w.onReady(async function () {
    await getAllImages()
});
async function getAllImages() {

    await setTimeout(async () => {

        items = (await wixData.query('Certificates').find()).items;
        let currentLanguge = wixWindow.multilingual.currentLanguage
        console.log(items);
        switch (currentLanguge) {
        case 'he':
            $w('#gallery28').items = items.filter(i => (i.imageHe && i.imageHe.length > 0)).map(i => ({
                type: "image",
                src: i.imageHe,
                title: i.title,
                
            }))
            break;
        default:
            $w('#gallery28').items = items.filter(i => (i.imageEn && i.imageEn.length > 0)).map(i => ({
                type: "image",
                src: i.imageEn,
                title: i.title,

            }))
            break;
        }

    }, 1000)
}